module.exports = __webpack_public_path__ + "static/media/majorF3.ee572d6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorF3.wav
// module id = zYQS
// module chunks = 0